import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { View, ScrollView, StyleSheet } from 'react-native';
import { PagerRendererPropType } from './PropTypes';

var PagerScroll =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PagerScroll, _React$Component);

  function PagerScroll(props) {
    var _this;

    _classCallCheck(this, PagerScroll);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PagerScroll).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_isIdle", true);

    _defineProperty(_assertThisInitialized(_this), "_isInitial", true);

    _defineProperty(_assertThisInitialized(_this), "_setInitialPage", function () {
      if (_this.props.layout.width) {
        _this._isInitial = true;

        _this._scrollTo(_this.props.navigationState.index * _this.props.layout.width, false);
      }

      setTimeout(function () {
        _this._isInitial = false;
      }, 50);
    });

    _defineProperty(_assertThisInitialized(_this), "_scrollTo", function (x) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (_this._isIdle && _this._scrollView) {
        _this._scrollView.scrollTo({
          x: x,
          animated: animated && _this.props.animationEnabled !== false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMomentumScrollEnd", function (e) {
      var nextIndex = Math.round(e.nativeEvent.contentOffset.x / _this.props.layout.width);
      var nextRoute = _this.props.navigationState.routes[nextIndex];

      if (_this.props.canJumpToTab({
        route: nextRoute
      })) {
        _this.props.jumpTo(nextRoute.key);

        _this.props.onAnimationEnd && _this.props.onAnimationEnd();
      } else {
        global.requestAnimationFrame(function () {
          _this._scrollTo(_this.props.navigationState.index * _this.props.layout.width);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleScroll", function (e) {
      if (_this._isInitial || e.nativeEvent.contentSize.width === 0) {
        return;
      }

      var _this$props = _this.props,
          navigationState = _this$props.navigationState,
          layout = _this$props.layout;
      var offset = navigationState.index * layout.width;

      _this.props.offsetX.setValue(-offset);

      _this.props.panX.setValue(offset - e.nativeEvent.contentOffset.x);

      global.cancelAnimationFrame(_this._idleCallback);
      _this._isIdle = false;
      _this._idleCallback = global.requestAnimationFrame(function () {
        _this._isIdle = true;
      });
    });

    var _this$props2 = _this.props,
        _navigationState = _this$props2.navigationState,
        _layout = _this$props2.layout;
    _this.state = {
      initialOffset: {
        x: _navigationState.index * _layout.width,
        y: 0
      }
    };
    return _this;
  }

  _createClass(PagerScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setInitialPage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var amount = this.props.navigationState.index * this.props.layout.width;

      if (prevProps.navigationState.routes.length !== this.props.navigationState.routes.length || prevProps.layout.width !== this.props.layout.width) {
        this._scrollTo(amount, false);
      } else if (prevProps.navigationState.index !== this.props.navigationState.index) {
        this._scrollTo(amount);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          layout = _this$props3.layout,
          navigationState = _this$props3.navigationState,
          onSwipeStart = _this$props3.onSwipeStart,
          onSwipeEnd = _this$props3.onSwipeEnd,
          bounces = _this$props3.bounces;
      return React.createElement(ScrollView, {
        horizontal: true,
        pagingEnabled: true,
        directionalLockEnabled: true,
        keyboardDismissMode: "on-drag",
        keyboardShouldPersistTaps: "always",
        overScrollMode: "never",
        scrollToOverflowEnabled: true,
        scrollEnabled: this.props.swipeEnabled,
        automaticallyAdjustContentInsets: false,
        bounces: bounces,
        alwaysBounceHorizontal: bounces,
        scrollsToTop: false,
        showsHorizontalScrollIndicator: false,
        scrollEventThrottle: 1,
        onScroll: this._handleScroll,
        onScrollBeginDrag: onSwipeStart,
        onScrollEndDrag: onSwipeEnd,
        onMomentumScrollEnd: this._handleMomentumScrollEnd,
        contentOffset: this.state.initialOffset,
        style: styles.container,
        contentContainerStyle: layout.width ? null : styles.container,
        ref: function ref(el) {
          return _this2._scrollView = el;
        }
      }, React.Children.map(children, function (child, i) {
        var route = navigationState.routes[i];
        var focused = i === navigationState.index;
        return React.createElement(View, {
          key: route.key,
          testID: _this2.props.getTestID({
            route: route
          }),
          accessibilityElementsHidden: !focused,
          importantForAccessibility: focused ? 'auto' : 'no-hide-descendants',
          style: layout.width ? {
            width: layout.width,
            overflow: 'hidden'
          } : focused ? styles.page : null
        }, focused || layout.width ? child : null);
      }));
    }
  }]);

  return PagerScroll;
}(React.Component);

_defineProperty(PagerScroll, "propTypes", _objectSpread({}, PagerRendererPropType, {
  bounces: PropTypes.bool.isRequired
}));

_defineProperty(PagerScroll, "defaultProps", {
  canJumpToTab: function canJumpToTab() {
    return true;
  },
  bounces: false
});

export { PagerScroll as default };
var styles = StyleSheet.create({
  container: {
    flex: 1
  },
  page: {
    flex: 1,
    overflow: 'hidden'
  }
});